import { render, staticRenderFns } from "./Machines.vue?vue&type=template&id=38364fa2&"
import script from "./Machines.vue?vue&type=script&lang=js&"
export * from "./Machines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports